@if (currentPromotions.ProductLevelPromotion) {
	<ng-template #promotionDrawerContent>
		<div class="product-promotion-container hmf-overflow-y-auto">
			<div id="promoPanelBody" [innerHTML]="currentPromotions.ProductLevelPromotion?.longDesc | bypassSanitization" class="hmf-p-md-l hmf-p-s"></div>
		</div>
	</ng-template>

	<div class="product-promotion-container">
		@for (key of currentPromotions | keys; track trackByFn($index, key)) {
			@if (!linkHref()) {
				<button class="promotion-description-text hmf-subheader-m label-sale hmf-p-0 hmf-text-align-left" (click)="onPromoClick()">{{ key?.value?.pdpDesc }}</button>
			} @else {
				<div [class]="textContainerClassList()">
					<a class="promotion-description-text hmf-subheader-m label-sale" [href]="linkHref()">{{ key?.value?.pdpDesc }}</a>
				</div>
			}
		}
	</div>
}

@if (ecodePromotion) {
	<div class="product-promotion-container ">
		@if (!linkHref()) {
			<ng-template #ecodePromotionDrawerContent>
				<div class="product-promotion-container hmf-overflow-y-auto">
					<div id="promoPanelBody" [innerHTML]="ecodePromotion.longDesc | bypassSanitization" class="hmf-p-md-l hmf-p-s"></div>
				</div>
			</ng-template>
                        <button class="promotion-description-text hmf-subheader-m label-sale hmf-text-align-left" (click)="openDrawer(true)">{{ ecodePromotion.pdpDesc }}</button>
		} @else {
			<div [class]="textContainerClassList()">
				<a class="promotion-description-text hmf-subheader-m label-sale" [href]="linkHref()">{{ ecodePromotion.pdpDesc }}</a>
			</div>
		}
	</div>
}
